<div class="flex flex-col gap-y-2.5">
    @if (label()) {
        <div class="text-medium-medium text-dark flex">
            {{ label() }}
            @if (required()) {
                <span class="text-red">*</span>
            }
        </div>
    }
    @if (textarea()) {
        <textarea
            type="text"
            name="input"
            [formControl]="control"
            [placeholder]="placeholder()"
            [class]="['input h-[186px] resize-none'] | joinClassNames"
        ></textarea>
    } @else {
        <input
            type="text"
            name="input"
            [mask]="mask()"
            [formControl]="control"
            [placeholder]="placeholder()"
            [class]="['input h-12', classNames(), type()] | joinClassNames"
        />
    }
    @if (control | input: label(); as errorMsg) {
        <span class="text-red text-small-regular">{{ errorMsg }}</span>
    }
</div>
